export const HOME_VIEW = {
  name: 'Dashboard',
  path: '/',
};

export const LOGIN_VIEW = {
  name: 'Login',
  path: '/auth/login',
};

export const ABOUT_VIEW = {
  name: 'About',
  path: '/about',
};

export const USERS_VIEW = {
  name: 'Users',
  path: '/users',
};

export const CASH_REGISTERS_VIEW = {
  name: 'CashRegisters',
  path: '/cash-registers',
};

export const SALES_DASHBOARD_VIEW = {
  name: 'SalesDashboard',
  path: '/sales-dashboard',
};

export const INVOICES_VIEW = {
  name: 'Invoices',
  path: '/invoices',
};

export const PAGE_NOT_FOUND = {
  name: 'PageNotFound',
  path: '/:pathMatch(.*)*',
};
